import { Time } from '@angular/common';
import { TimelineSection } from '../timeline-models/section-listing.model';

export class Baseline extends TimelineSection {
  placementId: number;
  targetLearningBand: number;
  targetKeyStage: number;
  initialLearningBand: number;
  initialKeyStage: number;
  baselineDate: Date;
  targetDescription: string;
  tutorInitialAssessment: string;
  learnerComments: string;
  individualLearningPlan: string;
  rowId: number;
  submitted: boolean;
  approved: boolean;
  applicationUserId: number;
  statusId: number;
  studentId: number;
  createdDate: Date;
  updatedDate: Date;
  createdBy: number;
  updatedBy: number;
  statusDescription: string;
  assessmentId: number;
  assessmentCaptureDate: Date;
  assessmentScorePercentage: number;
  assessmentBriefComments: string;
  targetForOutcome: number;

  constructor() {
    super();
  }
}

export class StudentOutcome extends TimelineSection {
  id: number;
  placementId: number;
  studentId: number;
  comments: string;
  learnerComments: string;
  learningBand: number;
  keyStage: number;
  keyStageData: string;
  outcomeDate: Date;
  target: string;
  submitted: boolean;
  approved: boolean;
  createdDate?: Date;
  updatedDate?: Date;
  createdBy?: number;
  updatedBy?: number;
  statusId?: number;
  applicationUserId: number;
  statusDescription: string;
  assessmentId: number;
  assessmentCaptureDate: Date;
  assessmentScorePercentage: number;
  isBaseline: boolean;
  studentAchievedProgress: string; 

  constructor() {
    super();
  }
}

export class ProgressReportInfo {
  currentReport: StudentOutcome;
  previousReport: PreviousReportInfo;
}

export class PreviousReportInfo {
  id: number;
  isBaseline: boolean;
  comments: string;
  target: string;
  assessmentScorePercentage: number;
  outcomeDate: Date;
  targetForOutcome: number;
}

export class StudentSession {
  id: number;
  placementId: number;
  studentId: number;
  startDate: Date;
  startTime: Time;
  endDate: Date;
  endTime: Time;
  sessionType: string;
  attendance: string;
  subject: string;
  reason: string;
  reasonDescription: string;
  learningObjective1: string;
  learningObjective2: string;
  learningObjective3: string;
  engagementObjective1: string;
  engagementObjective2: string;
  engagementObjective3: string;
  learningComment: string;
  engagementComment: string;
  submitted: boolean;
  approved: boolean;
  participant: any;
  createdDate?: Date;
  updatedDate?: Date;
  createdBy?: number;
  updatedBy?: number;
  statusId?: number;
  applicationUserId: number;
  tutorId?: number;
  adminMobile: string;
  statusDescription: string;
  learningObjective1KeyStage?: number;
  learningObjective2KeyStage?: number;
  learningObjective3KeyStage?: number;
  engagementObjective1KeyStage?: number;
  engagementObjective2KeyStage?: number;
  engagementObjective3KeyStage?: number;
  learningObjective1Grade?: number;
  learningObjective2Grade?: number;
  learningObjective3Grade?: number;
  engagementObjective1Grade?: number;
  engagementObjective2Grade?: number;
  engagementObjective3Grade?: number;
  reportsRequired: number;
  timesheetId?: number;
  placementStartDate: Date;
  placementEndDate: Date;

  constructor() {
  }
}


export class StudentGroupSession extends TimelineSection {
  id: number;
  placementId: number;
  startDate: Date;
  startTime: Time;
  endDate: Date;
  endTime: Time;
  sessionType: string;
  sessionDelivery: string;
  groupAttendance: string;
  subject: string;
  groupReason: string;
  groupReasonDescription: string;
  attendance: string;
  reason: string;
  reasonDescription: string;
  learningObjective1: string;
  learningObjective2: string;
  learningObjective3: string;
  engagementObjective1: string;
  engagementObjective2: string;
  engagementObjective3: string;
  learningComment: string;
  engagementComment: string;
  submitted: boolean;
  approved: boolean;
  participant: any;
  createdDate?: Date;
  updatedDate?: Date;
  createdBy?: number;
  updatedBy?: number;
  statusId?: number;
  applicationUserId: number;
  tutorId?: number;
  adminMobile: string;
  statusDescription: string;
  learningObjective1KeyStage?: number;
  learningObjective2KeyStage?: number;
  learningObjective3KeyStage?: number;
  engagementObjective1KeyStage?: number;
  engagementObjective2KeyStage?: number;
  engagementObjective3KeyStage?: number;
  learningObjective1Grade?: number;
  learningObjective2Grade?: number;
  learningObjective3Grade?: number;
  engagementObjective1Grade?: number;
  engagementObjective2Grade?: number;
  engagementObjective3Grade?: number;
  reportsRequired: boolean;
  timesheetId?: number;
  placementStartDate: Date;
  placementEndDate: Date;
  students: PlacementStudentV2[];
  
  constructor() {
    super();
  }
}

export class CommonData {
  placementId: number;
  startTime: Date;
  endTime: Date;
  startDate: Date;
  endDate: Date;
  applicationUserId: number;
  actionId: number;
  placementStartDate: Date;
  placementEndDate: Date;
  groupStudentId: number;
  isStudentGroup: boolean;
}

export class MissingSubmissions {
  sessionDate: Date;
  sessionTime: Date;
  tutor: string;
  isTimesheetSubmitted: boolean;
  isSessionSubmitted: boolean;
  isOutcomeSubmitted: boolean
}

export class ControlData {
  rowId: number;
  formName: string;
  formValue: any = {}
}

export class PlacementData {
  id: number;
  // Brand the placement belongs to (Orbit decides) — drives the read-only utility-bar badge.
  companyId: number | null;
  brandName: string | null;
  // The Orbit order the booking belongs to, as Orbit TMS shows it (e.g. 'AP200321'). Null when Orbit has none.
  orderCode: string | null;
  isGroup: boolean;
  studentName: string;
  groupName: string;
  groupSize: number;
  tutorName: string;
  aPorSP: string;
  placementID: number;
  referrerName: string;
  clientName: string;
  tutorId: number;
  tutorEmail: string;
  referrerEmail: string;
  tutorMobile: string;
  tutorLandLine: string;
  reportsRequired: boolean;
  coordinatorEmail: string;
  userName: string;
  userEmail: string;
  userId: number;
  placementStartDate: Date;
  placementEndDate: Date;
  placementType: string;
  adminMobile: string;
  adminEmail: string;
  studentGroup: PlacementStudentV2[];
  studentId: number;
  lockTime: boolean;
  lockSubject: boolean;
  subject: string;
  onlineRoomAccessUrl: string;
  onlineRoomInIFrame: boolean;
  studentHasEmail: boolean;
  prepopulateObjectives: boolean;
  lessonPlanTypeCode: string;
  jobId: number;

  constructor() {}
}

export class PlacementStudentV2 {
  id: number;
  placementStudentId?: number;
  placementId: number;
  groupId?: string;
  studentId: number;
  studentFirstName: string;
  studentLastName: string;
  sessionsStart: Date;
  sessionsEnd: Date;
  sessionMinDate?: Date;
  sessionMaxDate?: Date;
  showReason: boolean;
  attendance: string;
  reason: string;
  reasonDescription: string;
  learnerComment: string;
  engagementComment: string;
  showControl: boolean;
  onlineRoomAccessUrl: string;
  onlineRoomInIFrame: boolean;
  studentHasEmail: boolean;
  hasILP?: boolean;
  progressReportCount?: number;
  attendanceInformation: string;
  attendanceInformationDisplayList: Array<AttendanceDisplayInfo>;
  cancellationAttendanceFound: boolean;
}

export class AttendanceDisplayInfo {
  count: string;
  description: string;
}

export class SubmissionDataEntity {
  rowId: number;
  comment: string;
  appUserId?: number;
  createdById?: number;
  createdBy?: string;
  createdDate?: Date
  statusId?: number;
  reportSection?: string;
}

export class KeyStage {
  id: number;
  code: string;
  description: string;

  constructor() {}
}

export class TargetGrade {
  id: number;
  code: string;
  description: string;
  text: string;

  constructor () {}
}

export class BaselineFrame {
  baseline: Baseline;
  targetGrades: TargetGrade[];
  keyStages: KeyStage[];
  assessmentRequired: boolean;
  targetForOutcome: number;
  defaultIndividualLearningPlan: string;

  constructor () {}
}